module.exports = __webpack_public_path__ + "static/media/8-b-05217840-aa-829-faf-00701-f-61-e-0-bbdb@3x.64640958.png";